exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".date-time-picker .field-input {\n  color: #6e7d87;\n  font-weight: 600;\n  font-size: 16px;\n  font-family: \"open sans\", Whitney, Lato, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n  border: 1px solid #b0b9bf !important;\n}\n.date-time-picker .field-input:focus {\n  border-color: #5db2fd;\n  box-shadow: 0 0 0 .2rem rgba(3, 116, 215, .25);\n}\n", ""]);

// exports
